import { render, staticRenderFns } from "./MoonBackground.vue?vue&type=template&id=92b203fe&scoped=true&"
import script from "./MoonBackground.vue?vue&type=script&lang=js&"
export * from "./MoonBackground.vue?vue&type=script&lang=js&"
import style0 from "./MoonBackground.vue?vue&type=style&index=0&id=92b203fe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b203fe",
  null
  
)

export default component.exports